/**
 * Theme Logger v1.0.0
 * ═══════════════════════════════════════════════════════════════════════════════
 *
 * Minimal, debug.js-inspired namespaced logger.
 * Toggle via localStorage: debug=true, debug:filter=cart:*
 *
 * Usage:
 *   const log = Theme.Logger.ns('cart');
 *   log.debug('Added item', { id: 123 });
 *
 * ═══════════════════════════════════════════════════════════════════════════════
 */

(function() {
  'use strict';

  window.Theme = window.Theme || {};

  const Logger = (() => {
    const buffer = [];
    const MAX = 500;
    const timers = {};
    let last = Date.now();

    // Settings from localStorage
    let on = false;
    let filter = null;

    try {
      on = localStorage.getItem('debug') === 'true';
      filter = localStorage.getItem('debug:filter');
    } catch (e) {}

    // Timing: +0ms, +142ms, +2.1s
    const diff = () => {
      const now = Date.now();
      const d = now - last;
      last = now;
      return d < 1000 ? `+${d}ms` : `+${(d / 1000).toFixed(1)}s`;
    };

    // Color from string hash
    const color = (s) => {
      let h = 0;
      for (let i = 0; i < s.length; i++) h = s.charCodeAt(i) + ((h << 5) - h);
      return `hsl(${h % 360}, 70%, 40%)`;
    };

    // Check if namespace matches filter
    const match = (ns) => {
      if (!filter) return true;
      return filter.split(',').some(p => {
        p = p.trim();
        if (p === '*') return true;
        if (p.endsWith(':*')) return ns.startsWith(p.slice(0, -1));
        return ns === p;
      });
    };

    // Create namespaced logger
    const ns = (namespace) => {
      const c = color(namespace);

      const log = (level, msg, data) => {
        const entry = { t: Date.now(), ns: namespace, l: level, m: msg };
        if (data !== undefined) entry.d = data;
        buffer.push(entry);
        if (buffer.length > MAX) buffer.shift();

        if (!on && level !== 'error') return;
        if (!match(namespace)) return;

        const method = level === 'debug' ? 'log' : level;
        const d = diff();
        const fmt = `%c[${namespace}]%c ${msg} %c${d}`;
        data !== undefined
          ? console[method](fmt, `color:${c};font-weight:bold`, '', 'color:#999', data)
          : console[method](fmt, `color:${c};font-weight:bold`, '', 'color:#999');
      };

      return {
        debug: (msg, data) => log('debug', msg, data),
        info:  (msg, data) => log('info', msg, data),
        warn:  (msg, data) => log('warn', msg, data),
        error: (msg, data) => log('error', msg, data),
      };
    };

    return {
      ns,
      enable:  () => { on = true;  try { localStorage.setItem('debug', 'true'); } catch(e){} },
      disable: () => { on = false; try { localStorage.removeItem('debug'); } catch(e){} },
      filter:  (p) => { filter = p; try { localStorage.setItem('debug:filter', p); } catch(e){} },
      clearFilter: () => { filter = null; try { localStorage.removeItem('debug:filter'); } catch(e){} },
      dump: () => [...buffer],
      tail: (n = 20) => buffer.slice(-n),
      clear: () => { buffer.length = 0; },
      time: (label) => { timers[label] = performance.now(); },
      timeEnd: (label) => {
        if (!timers[label]) return;
        const ms = Math.round(performance.now() - timers[label]);
        delete timers[label];
        ns('perf').info(`${label}: ${ms}ms`);
        return ms;
      },
      get enabled() { return on; },
    };
  })();

  window.Theme.Logger = Logger;

  Logger.ns('logger').info('Logger v1.0.0 loaded');
})();
